// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"943cc65b","787":"1342cae8"}[chunkId] + ".chunk.js";
};